import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import { UserSharingPermissionFragmentDoc } from '../../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateUserSharingPermissionMutationVariables = Types.Exact<{
  input: Types.UpdateUserSharingPermissionInput;
}>;


export type UpdateUserSharingPermissionMutation = { __typename?: 'Mutation', updateUserSharingPermission: { __typename?: 'UserSharingPermissionMutationResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, userSharingPermission?: { __typename?: 'UserSharingPermission', id: string, permission: Types.SharingPermission, user: { __typename?: 'Employee', id: number, name: string, userType: Types.UserType } } | null } };

export type RemoveUserSharingPermissionMutationVariables = Types.Exact<{
  input: Types.RemoveUserSharingPermissionInput;
}>;


export type RemoveUserSharingPermissionMutation = { __typename?: 'Mutation', removeUserSharingPermission: { __typename?: 'UserSharingPermissionMutationResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null } };


export const UpdateUserSharingPermissionDocument = gql`
    mutation updateUserSharingPermission($input: UpdateUserSharingPermissionInput!) {
  updateUserSharingPermission(input: $input) {
    success
    error {
      code
      message
    }
    userSharingPermission {
      ...UserSharingPermission
    }
  }
}
    ${UserSharingPermissionFragmentDoc}`;
export type UpdateUserSharingPermissionMutationFn = Apollo.MutationFunction<UpdateUserSharingPermissionMutation, UpdateUserSharingPermissionMutationVariables>;

/**
 * __useUpdateUserSharingPermissionMutation__
 *
 * To run a mutation, you first call `useUpdateUserSharingPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSharingPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSharingPermissionMutation, { data, loading, error }] = useUpdateUserSharingPermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSharingPermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSharingPermissionMutation, UpdateUserSharingPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSharingPermissionMutation, UpdateUserSharingPermissionMutationVariables>(UpdateUserSharingPermissionDocument, options);
      }
export type UpdateUserSharingPermissionMutationHookResult = ReturnType<typeof useUpdateUserSharingPermissionMutation>;
export type UpdateUserSharingPermissionMutationResult = Apollo.MutationResult<UpdateUserSharingPermissionMutation>;
export type UpdateUserSharingPermissionMutationOptions = Apollo.BaseMutationOptions<UpdateUserSharingPermissionMutation, UpdateUserSharingPermissionMutationVariables>;
export const RemoveUserSharingPermissionDocument = gql`
    mutation removeUserSharingPermission($input: RemoveUserSharingPermissionInput!) {
  removeUserSharingPermission(input: $input) {
    success
    error {
      code
      message
    }
  }
}
    `;
export type RemoveUserSharingPermissionMutationFn = Apollo.MutationFunction<RemoveUserSharingPermissionMutation, RemoveUserSharingPermissionMutationVariables>;

/**
 * __useRemoveUserSharingPermissionMutation__
 *
 * To run a mutation, you first call `useRemoveUserSharingPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserSharingPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserSharingPermissionMutation, { data, loading, error }] = useRemoveUserSharingPermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserSharingPermissionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserSharingPermissionMutation, RemoveUserSharingPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserSharingPermissionMutation, RemoveUserSharingPermissionMutationVariables>(RemoveUserSharingPermissionDocument, options);
      }
export type RemoveUserSharingPermissionMutationHookResult = ReturnType<typeof useRemoveUserSharingPermissionMutation>;
export type RemoveUserSharingPermissionMutationResult = Apollo.MutationResult<RemoveUserSharingPermissionMutation>;
export type RemoveUserSharingPermissionMutationOptions = Apollo.BaseMutationOptions<RemoveUserSharingPermissionMutation, RemoveUserSharingPermissionMutationVariables>;